import { Link as RouterLink } from 'react-router-dom';

const articles = [
  {
    title: 'Superbuy Spreadsheet Complete Guide 2026',
    desc: 'The ultimate beginner-to-advanced walkthrough covering everything from product discovery to smart shopping strategies.',
    path: '/superbuy-spreadsheet-complete-guide',
    icon: 'ri-book-read-line',
    readTime: '12 min read',
  },
  {
    title: 'Best Superbuy Spreadsheet Shoes Guide',
    desc: 'Discover premium footwear in minutes. Sneakers, dress shoes, casual wear, and limited releases — organized for quick comparison.',
    path: '/superbuy-spreadsheet-shoes-guide',
    icon: 'ri-footprint-line',
    readTime: '10 min read',
  },
  {
    title: 'Superbuy Spreadsheet vs Alternatives',
    desc: 'Honest comparison against manual browsing, social media groups, shared spreadsheets, and video reviews. See which method fits your style.',
    path: '/superbuy-spreadsheet-vs-alternatives',
    icon: 'ri-scales-3-line',
    readTime: '14 min read',
  },
  {
    title: 'Superbuy Spreadsheet Beginner Tutorial',
    desc: 'A friendly step-by-step walkthrough for absolute beginners. Learn to navigate categories and make your first informed purchase in 10 minutes.',
    path: '/superbuy-spreadsheet-beginner-tutorial',
    icon: 'ri-user-smile-line',
    readTime: '8 min read',
  },
  {
    title: 'Superbuy Spreadsheet Tips & Tricks',
    desc: '15 expert strategies for smarter shopping. Cross-category browsing, seasonal timing, efficiency hacks, and workflow optimization.',
    path: '/superbuy-spreadsheet-tips-tricks',
    icon: 'ri-lightbulb-line',
    readTime: '11 min read',
  },
  {
    title: 'Superbuy Spreadsheet Safety Guide',
    desc: 'Everything about secure shopping and privacy protection. Recognizing fake sites, avoiding scams, and responsible purchasing practices.',
    path: '/superbuy-spreadsheet-safety-guide',
    icon: 'ri-shield-check-line',
    readTime: '10 min read',
  },
  {
    title: 'Superbuy Spreadsheet Product Discovery Guide',
    desc: 'Master the art of finding hidden gems fast. Systematic browsing techniques and category exploration strategies that pros use.',
    path: '/superbuy-spreadsheet-product-discovery',
    icon: 'ri-search-eye-line',
    readTime: '9 min read',
  },
  {
    title: 'Superbuy Spreadsheet Review 2026',
    desc: 'An honest, detailed assessment after extensive use. Category coverage, organizational quality, educational value, and who should use it.',
    path: '/superbuy-spreadsheet-review-2026',
    icon: 'ri-star-line',
    readTime: '13 min read',
  },
];

export default function ArticleLinks() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            In-Depth Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Superbuy Spreadsheet Resources
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Dive deeper with our comprehensive guides and articles. Each resource is written to help you get the most out of the Superbuy Spreadsheet platform.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {articles.map((article) => (
            <RouterLink
              key={article.path}
              to={article.path}
              className="group flex flex-col gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors duration-200">
                  <i className={`${article.icon} text-primary-600 text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                    <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 leading-snug">
                      {article.title}
                    </h3>
                    <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {article.readTime}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{article.desc}</p>
                </div>
              </div>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 whitespace-nowrap self-start">
                Read Full Guide
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
              </span>
            </RouterLink>
          ))}
        </div>
      </div>
    </section>
  );
}